import { Phone, Mail, MapPin } from "lucide-react";
import { ASSETS, CONTACT } from "@/lib/assets";

export default function Footer() {
  return (
    <footer className="relative border-t hairline pt-16 pb-10" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img src={ASSETS.logoIcon} alt="" className="w-12 h-12" />
              <div>
                <div className="text-lg font-bold text-white tracking-wide">
                  HØIE <span className="text-coral">SERVICE</span> AS
                </div>
                <div className="mono text-[10px] uppercase tracking-[0.22em] text-white/50">
                  Ditt innemiljø er vårt fokus
                </div>
              </div>
            </div>
            <p className="text-white/60 text-sm max-w-md leading-relaxed">
              Lokalt håndverkerfirma som spesialiserer seg på energi­oppgradering
              av boliger i Sveio og resten av Vestland.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="mono text-[10px] uppercase tracking-[0.22em] text-cyan mb-4">
              / Tjenester
            </div>
            <ul className="space-y-2 text-white/70 text-sm">
              <li>Varmepumpe service</li>
              <li>Etterisolering</li>
              <li>Vindtetting</li>
              <li>Kledning</li>
              <li>Vinduer & dører</li>
              <li>Porter & terrasser</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="mono text-[10px] uppercase tracking-[0.22em] text-coral mb-4">
              / Kontakt
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 text-white/80 hover:text-cyan transition">
                  <Phone className="w-4 h-4" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-white/80 hover:text-cyan transition break-all">
                  <Mail className="w-4 h-4 shrink-0" /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/80">
                <MapPin className="w-4 h-4" /> {CONTACT.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-8 border-t hairline">
          <div className="mono text-[11px] uppercase tracking-[0.22em] text-white/40">
            © {new Date().getFullYear()} Høie Service AS · Org.nr {CONTACT.orgNr}
          </div>
          <div className="mono text-[11px] uppercase tracking-[0.22em] text-white/40">
            Energi · Komfort · Verdiøkning
          </div>
        </div>
      </div>
    </footer>
  );
}
